import { render, staticRenderFns } from "./CollapsePanelSmallLink.vue?vue&type=template&id=296eaacf&scoped=true"
import script from "./CollapsePanelSmallLink.vue?vue&type=script&lang=js"
export * from "./CollapsePanelSmallLink.vue?vue&type=script&lang=js"
import style0 from "./CollapsePanelSmallLink.vue?vue&type=style&index=0&id=296eaacf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296eaacf",
  null
  
)

export default component.exports